import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { Spinner } from './Spinner';
import './components.css';

type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: 'default' | 'large';
  fullWidth?: boolean;
  isLoading?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'primary', size = 'default', fullWidth, isLoading, disabled, children, className, ...rest },
  ref
) {
  const classes = [
    'btn',
    `btn--${variant}`,
    size === 'large' ? 'btn--large' : '',
    fullWidth ? 'btn--full' : '',
    className ?? ''
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button ref={ref} className={classes} disabled={disabled || isLoading} {...rest}>
      {isLoading && <Spinner />}
      {children}
    </button>
  );
});
